import { render, staticRenderFns } from "./CurriculumSteps.vue?vue&type=template&id=dbb537b4&scoped=true&"
import script from "./CurriculumSteps.vue?vue&type=script&lang=js&"
export * from "./CurriculumSteps.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumSteps.vue?vue&type=style&index=0&id=dbb537b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb537b4",
  null
  
)

export default component.exports